const hamburger = document.getElementById('hamburger');
const closeBtn = document.getElementById('close-btn');
const navMobile = document.getElementById('nav-mobile');
const overlay = document.getElementById('overlay');
const header = document.querySelector("header.header")


if (header){
  const add_class_on_scroll = () => header.classList.add("fixed-on");
  const add_class_on_scrollDown = () => header.classList.add("fixed-off")
  const remove_class_on_scroll = () => header.classList.remove("fixed-on")
  const remove_class_on_scrollDown = () => header.classList.remove("fixed-off")
  var lastScrollTopTemp = 0;
  var noHoverHeader;

  if (hamburger && navMobile){
    hamburger.addEventListener('click', () => {
      navMobile.classList.add('open');
      document.body.style.overflow = 'hidden';
      overlay.style.display = 'block';
    });
  }

  if (closeBtn && navMobile){
    closeBtn.addEventListener('click', () => {
      navMobile.classList.remove('open');
      document.body.style.overflow = 'auto';

      overlay.style.display = 'none';
    });
  }
  if (overlay && navMobile){
    overlay.addEventListener('click', () => {
      navMobile.classList.remove('open');
      document.body.style.overflow = 'auto';

      overlay.style.display = 'none';
    });
  }


  const menuContainer = document.querySelector("header.header");
  
// Seleziona tutti i link del menu che contengono un href con "#"
const menuLinks = menuContainer.querySelectorAll('a[href*="#"]');

    menuLinks.forEach(link => {

      link.addEventListener("click", function (event) {
            event.preventDefault(); // Evita il comportamento predefinito
            //const targetId = this.getAttribute("href").substring(1); // Rimuove il #
            const hash = this.hash; // ad es. "#timeline"
            const targetElement = document.querySelector(hash);
            if (targetElement) {
              // menuContainer.classList.remove("show");
              document.body.style.overflow = 'auto';
              //navMobile.classList.remove('open');
              if (document.querySelector("#overlay.overlay")){
                document.querySelector("#overlay.overlay").style.display= "none";
              }

              //setTimeout(function(){remove_class_on_scroll();hash == "#home" ? remove_class_on_scrollDown() : add_class_on_scrollDown();},900);	

              targetElement.scrollIntoView({
                    behavior: "smooth", // Scroll fluido
                    block: "start" // Allinea l'elemento in alto
                });

            }
        });
    });
  

  window.addEventListener("scroll", function(e) { 
    scrollpos = window.scrollY;
    var st = window.pageYOffset || document.documentElement.scrollTop; 
    //if onTOP
    if (scrollpos<=0){
      remove_class_on_scroll();
      //remove_class_on_scrollDown();
      
    }else{
      
     add_class_on_scroll();
      // if (st > lastScrollTopTemp) {
      //   remove_class_on_scroll();
      //   add_class_on_scrollDown();
      //   clearTimeout(noHoverHeader);
      // } else if (st < lastScrollTopTemp) {
      //   add_class_on_scroll();
      //   remove_class_on_scrollDown();
      //   clearTimeout(noHoverHeader);
      //   noHoverHeader = setTimeout(function(){remove_class_on_scroll();add_class_on_scrollDown();},1500);				
      // } 	
    }
    lastScrollTopTemp = st <= 0 ? 0 : st; // For Mobile or negative scrolling
});

//remove timeout on mouseover header
header.addEventListener("mouseover", function( event ) {
    clearTimeout(noHoverHeader);
  }, false);	
}

// Seleziona tutti gli elementi che devono essere animati
const elements = document.querySelectorAll('.fade-in-right, .fade-in-left, .fade-in-up, .fade-in-down');

// Crea l'observer con il callback
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      // Ottieni il ritardo dall'attributo data-anim-start o imposta a 0 se non presente
      let delay = parseInt(entry.target.dataset.animStart) || 0;
        //console.log("desktop",delay);
      if (window.innerWidth < 600){
        //delay = Math.abs(delay - (delay*1.1)); 
        //console.log("mbile",delay);
      }
      // Applica l'animazione con il ritardo specificato
      setTimeout(() => {
        entry.target.classList.add('show');
      }, delay);

      // Interrompi l'osservazione dopo aver applicato l'animazione
      observer.unobserve(entry.target);
    }
  });
}, { threshold: 0.3 });

// Osserva ciascun elemento selezionato
elements.forEach(el => {
  observer.observe(el);
});


document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.getElementById('shareToggle');
  const menu = document.getElementById('shareMenu');

  let hideTimeout;

  toggle.addEventListener('click', (e) => {
    e.preventDefault();

    if (menu.classList.contains('show')) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  function openMenu() {
    clearTimeout(hideTimeout);
    menu.style.display = 'flex';
    setTimeout(() => menu.classList.add('show'), 10);
  }

  function closeMenu() {
    clearTimeout(hideTimeout);
    menu.classList.remove('show');
    setTimeout(() => menu.style.display = 'none', 300); // attende il fade-out
  }

  // Chiudi quando clicchi/tocchi fuori dal menu
  document.addEventListener('click', (e) => {
    if (
      menu.classList.contains('show') &&
      !menu.contains(e.target) &&
      !toggle.contains(e.target)
    ) {
      closeMenu();
    }
  });

  // Avvia chiusura automatica quando il mouse esce (desktop)
  menu.addEventListener('mouseleave', () => {
    hideTimeout = setTimeout(closeMenu, 1200);
  });

  // Annulla la chiusura se il mouse rientra (desktop)
  menu.addEventListener('mouseenter', () => {
    clearTimeout(hideTimeout);
  });

  document.querySelectorAll('.share-item').forEach(item => {
    item.addEventListener('click', (e) => {
      e.preventDefault();
      const platform = item.dataset.platform;
      const url = encodeURIComponent(window.location.href);
      const text = encodeURIComponent("Leggi, guarda e ascolta le news dall'Italia e dal mondo sul tuo smartphone: scarica l'app di LaC News24");

      let shareUrl = '';
      switch (platform) {
        case 'whatsapp':
          shareUrl = `https://wa.me/?text=${text}%20${url}`;
          break;
        case 'instagram':
          alert("Instagram non supporta condivisione diretta, copia il link.");
          return;
        case 'x':
          shareUrl = `https://twitter.com/intent/tweet?text=${text}&url=${url}`;
          break;
        case 'facebook':
          shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
          break;
        case 'copy':
          navigator.clipboard.writeText(window.location.href);
          alert("Link copiato!");
          closeMenu();
          return;
        case 'email':
          shareUrl = `mailto:?subject=${text}&body=${url}`;
          break;
      }
      if (shareUrl) {
        window.open(shareUrl, '_blank');
        closeMenu();
      }
    });
  });
});


document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth > 850) return;

  const container = document.querySelector(".scroll-container");
  const list = document.getElementById("scrollList");

  // Aspetta caricamento immagini originali
  const imgs = Array.from(list.querySelectorAll("img"));
  Promise.all(imgs.map(img => (
    img.complete
      ? Promise.resolve()
      : new Promise(res => {
          img.addEventListener("load", res, { once: true });
          img.addEventListener("error", res, { once: true });
        })
  ))).then(() => {
    // Larghezza set originale
    const originalWidth = list.scrollWidth;

    // Duplica elementi per effetto continuo
    list.innerHTML += list.innerHTML;

    // Imposta variabili CSS
    const speed = 50; // px/sec
    const duration = originalWidth / speed;
    list.style.setProperty("--loop-distance", `${originalWidth}px`);
    list.style.setProperty("--duration", `${duration}s`);
  });

  // Stop su hover/touch
  container.addEventListener("mouseenter", () => container.classList.add("paused"));
  container.addEventListener("mouseleave", () => container.classList.remove("paused"));
  container.addEventListener("touchstart", () => container.classList.add("paused"), { passive: true });
  container.addEventListener("touchend", () => container.classList.remove("paused"));
});

if (window.visualViewport) {
  const overlay = document.querySelector('.overlay-mobile');

  const updatePosition = () => {

    // iOS Safari riconoscimento semplice via userAgent
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

    if (isIOS) {
        const bottomInset = window.innerHeight - window.visualViewport.height;
        overlay.style.bottom = `${bottomInset}px`;
    } else {
      // Android o altri browser
      //overlay.style.bottom = `${bottomInset}px`;
    }
  };

  window.visualViewport.addEventListener('resize', updatePosition);
  //window.visualViewport.addEventListener('scroll', updatePosition); // utile su Safari
  updatePosition();
}


// function setupScrolling() {
//     const wrapper = document.querySelector('.scroll-wrapper');
//     const track = document.querySelector('.scroll-track');

//     // Rimuovi cloni esistenti (evita duplicazioni infinite)
//     const originals = Array.from(track.children).filter(el => !el.classList.contains('clone'));
//     track.innerHTML = '';
//     originals.forEach(el => track.appendChild(el));

//     // Calcola la larghezza totale del contenuto originale
//     const contentWidth = originals.reduce((total, el) => total + el.offsetWidth + 20, 0); // 20 = gap

//     // Duplica finché non riempi almeno 2x la larghezza del wrapper
//     const wrapperWidth = wrapper.offsetWidth;
//     let currentWidth = contentWidth;
//     while (currentWidth < wrapperWidth * 2) {
//       originals.forEach(el => {
//         const clone = el.cloneNode(true);
//         clone.classList.add('clone');
//         track.appendChild(clone);
//         currentWidth += el.offsetWidth + 20;
//       });
//     }

//     // Imposta durata in base alla lunghezza totale
//     const duration = currentWidth / 100; // tuning: più alto = più lento
//     track.style.animationDuration = `${duration}s`;
//   }

//   // Esegui all'avvio e al resize
//   window.addEventListener('DOMContentLoaded', setupScrolling);
//   window.addEventListener('resize', () => {
//     setupScrolling();
//   });